/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';
import * as _ from 'lodash';

@Component({
  standalone: false,
  selector: 'adn-targeting-weather-summary',
  template: '<span *ngIf="output">{{output}}</span>'
})
export class WeatherSummaryComponent implements OnChanges {
  @Input() targets: any;

  output = '';

  ngOnChanges(): void {
    this.output = '';
    const target = this.targets;
    if (_.get(target, [0])) {
      const weather = target[0];
      if (_.isFinite(weather.value) && weather.type) {
        this.output = weather.value + '°C and ' + (weather.type === 'ABOVE_CELSIUS' ? 'above' : 'below');
      }
    }
  }
}
